import type { Permission } from "src/api/client-api/permissions/useGetAllPermissions";

export type PermissionScopeValue = "org" | "platform";

export const ORG_SCOPED_OBJECTS = new Set<string>([
    "company",
    "ingredient",
    "packaging",
    "product",
    "action-plan",
    "ingredient-supplier-activity-data",
    "company-settings",
    "product-activity-data",
    "product-settings-organization",
]);

export const resolvePermissionScope = (permission: Permission): PermissionScopeValue => {
    return permission.scope ?? (ORG_SCOPED_OBJECTS.has(permission.object) ? "org" : "platform");
};

export const deriveRoleScope = (
    selectedIds: Set<string>,
    allPermissions: Permission[],
): PermissionScopeValue | null => {
    const firstSelected = allPermissions.find((permission) => selectedIds.has(permission["@id"]));

    return firstSelected ? resolvePermissionScope(firstSelected) : null;
};

export const permissionIdsOfObjectInScope = (
    permissions: Permission[],
    object: string,
    scope: PermissionScopeValue | null,
): Set<string> =>
    new Set(
        permissions
            .filter((permission) => permission.object === object && resolvePermissionScope(permission) === scope)
            .map((permission) => permission["@id"]),
    );
